/* eslint-disable import/first */
import Vue from "vue";
import {EventBus} from "../../event-bus.js";
import VueRouter from "vue-router";
Vue.use(VueRouter);
import List from "./components/List.vue";
import Edit from "./components/Edit.vue";
import {afterEachRouteChange} from "../router-helpers.js";

export function buildRouter() {
	const routes = [
		{path: "/list", component: List},
		{path: "/edit/:id", component: Edit, props: true, meta: {pageTitle: "Edit Address", parent: "/list"}},
		{path: "/create", component: Edit, props: {isNew: true, default: true}, meta: {pageTitle: "New Mail to Fax Address", parent: "/list"}}
	];

	const router = new VueRouter({
		routes, mode: "abstract"
	});
	router.afterEach(afterEachRouteChange(routes, EventBus, router));
	return {router};
}
